import { render, staticRenderFns } from "./consumer.vue?vue&type=template&id=31dfdaaf&scoped=true"
import script from "./consumer.vue?vue&type=script&lang=js"
export * from "./consumer.vue?vue&type=script&lang=js"
import style0 from "./consumer.vue?vue&type=style&index=0&id=31dfdaaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dfdaaf",
  null
  
)

export default component.exports